import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ResponseCatalog, RequestParams } from 'Models'
import { City } from 'Pages/orders_design'
import { GetItemsPayload } from 'Types/getItemsPayload'

export type CityState = {
	items: ResponseCatalog<City>
	params: RequestParams
}

export const cityInitialState: CityState = {
	items: new ResponseCatalog<City>(),
	params: new RequestParams(),
}

export namespace cityNS {
	export type getCities = PayloadAction<GetItemsPayload>
	export type getCitiesMissing = PayloadAction<number>
	export type setCities = PayloadAction<ResponseCatalog<City>>
	export type setParamsCities = PayloadAction<RequestParams>
}

export const citySlice = createSlice({
	name: 'city',
	initialState: cityInitialState,
	reducers: {
		getCities: (state, action: cityNS.getCities) => {},
		getCitiesMissing: (state, action: cityNS.getCitiesMissing) => {},
		setCities: (state, action: cityNS.setCities) => {
			state.items = action.payload
		},
		setParamsCities: (state, action: cityNS.setParamsCities) => {
			state.params = action.payload
		},
		clearAll: (state) => {
			state.items = new ResponseCatalog<City>()
			state.params = new RequestParams()
		},
	},
})
